import script from "./loginYy.vue?vue&type=script&setup=true&lang=js"
export * from "./loginYy.vue?vue&type=script&setup=true&lang=js"

import "./loginYy.vue?vue&type=style&index=0&id=0b712924&lang=less"

const __exports__ = script;

export default __exports__